<template lang="pug">
  .payment-method
    component.preview(:is="component" v-bind="properties" @click.prevent.stop="select")
      slot(name="icon")
        .icon
          svg(
            v-if="active"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            )
          .empty-checkbox(v-else)
            .circle
      .data
        .field-preview
          .label(v-if="showLabel") Versand
          .field-value {{ data.name }}
          .field-value(v-if="fee") {{ fee | moneyFormat(currency) }}
    hr.my-4(v-if="showDivider")
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from '@/helpers';
import { getShippingFee } from '@/extensions/shop/helpers';

export default {
  name: 'ShippingMethod',
  props: {
    data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    showDivider: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      let component = 'a';
      if (this.active) component = 'div';
      return component;
    },
    properties() {
      let properties = {};
      if (this.component === 'a') {
        properties.href = '#';
      }
      return properties;
    },
    currency() {
      return (
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR'
      );
    },
    fee() {
      return getShippingFee(this.data);
    },
    ...mapGetters({
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup'
    })
  },
  methods: {
    select() {
      this.$emit('click', this.data);
      if (!this.active) this.$emit('select', this.data);
    }
  }
};
</script>

<style lang="sass" scoped>
.empty-checkbox
  @apply flex justify-center items-center
  width: 3rem
  height: 3rem
  .circle
    @apply border-2 border-gray-400
    width: 1.5rem
    height: 1.5rem
    border-radius: 50%

.spinner-container
  min-height: 4rem
</style>
